import './wdyr';
import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { NativeObjectsContextProvider, FreshdeskContextProvider, ManageTranslationsContextProvider } from 'store';
import { MessageChannelContextProvider } from 'store/message-channel-context';
import App from 'App';
import './index.css';
import '@freshworks/crayons/css/dew-min.css';
import ThemeWrapper from 'store/theme-wrapper';

ReactDOM.render(
  <React.StrictMode>
    <DndProvider backend={HTML5Backend}>
      <ThemeWrapper>
        <MessageChannelContextProvider>
          <FreshdeskContextProvider>
            <ManageTranslationsContextProvider>
              <NativeObjectsContextProvider>
                <App />
              </NativeObjectsContextProvider>
            </ManageTranslationsContextProvider>
          </FreshdeskContextProvider>
        </MessageChannelContextProvider>
      </ThemeWrapper>
    </DndProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
